export type ExcludedPayrollElements = Record<string, string[]>

const PAYROLL_SUMMARY_SECTION_KEYS = new Set([
  "earnings",
  "deductions",
  "contributions",
  "amortizations",
])

export const parseExcludedPayrollElements = (
  value: string | null
): ExcludedPayrollElements => {
  if (!value) return {}

  try {
    const parsed: unknown = JSON.parse(value)
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed))
      return {}

    return Object.entries(parsed).reduce<ExcludedPayrollElements>(
      (result, [section, elements]) => {
        if (
          !PAYROLL_SUMMARY_SECTION_KEYS.has(section) ||
          !Array.isArray(elements)
        )
          return result

        const validElements = Array.from(
          new Set(
            elements
              .filter(
                (element): element is string => typeof element === "string"
              )
              .map((element) => element.trim())
              .filter(Boolean)
          )
        )
        if (validElements.length) result[section] = validElements
        return result
      },
      {}
    )
  } catch {
    return {}
  }
}

export const serializeExcludedPayrollElements = (
  exclusions: ExcludedPayrollElements
): string | undefined => {
  const populatedEntries = Object.entries(exclusions)
    .filter(([, elements]) => elements.length > 0)
    .sort(([left], [right]) => left.localeCompare(right))

  return populatedEntries.length
    ? JSON.stringify(Object.fromEntries(populatedEntries))
    : undefined
}
